<div class="app-screen-size--{{ currentScreenSize }}">
  @if (showSpinner) {
    <app-module-loader />
  }
  <router-outlet />
</div>
